import { ArrowIcon } from '@modusign/design-system';
import PropTypes from 'prop-types';
import { Component } from 'react';
import DropZone from 'react-dropzone';

import logoSizeImage from '@app/assets/modal/email-custom-logo-upload-modal/img-logo-size.jpg';

import './LogoImageDropZone.scss';

const ACCEPT_FILETYPE = ['jpg', 'jpeg', 'png'];
const MAX_FILE_SIZE = 1024 * 300;

const propTypes = {
  onChange: PropTypes.func,
  onModalOpen: PropTypes.func,
};

const defaultProps = {
  onChange() {},
  onModalOpen() {},
};

class LogoImageDropZone extends Component {
  constructor(props) {
    super(props);
    this.handleConvertImageToBase64 = this.handleConvertImageToBase64.bind(this);
    this.handleClickFile = this.handleClickFile.bind(this);
    this.handleOnChange = this.handleOnChange.bind(this);
    this.handleOnDrop = this.handleOnDrop.bind(this);
    this.handleOnLoadImage = this.handleOnLoadImage.bind(this);
  }

  handleClickFile(e) {
    e.preventDefault();
    this.dropzoneRef.open();
  }

  handleConvertImageToBase64({ base64, fileName }) {
    // 이미지 크기를 확인하고 경고창 띄운다.
    const imageObject = new Image();
    imageObject.src = base64;
    imageObject.onload = (event) => this.handleOnLoadImage(event, { base64, fileName });
  }

  handleOnChange(image) {
    const { onChange } = this.props;
    onChange(image);
  }

  handleOnLoadImage(event, image) {
    const { base64, fileName } = image;
    const parsing = fileName.split('.');
    const extension = parsing.pop().toLowerCase();
    const { onModalOpen } = this.props;
    const { height, width } = event.target;
    const isOverSize = height > 80 || width > 250;
    if (isOverSize) {
      onModalOpen('CUSTOM_EMAIL_SETTING_LOGO_IMAGE_CONSTRAINTS_ALERT_MODAL', {
        alertType: 'imageSize',
      });
    } else {
      this.handleOnChange({
        logo: {
          base64,
          height,
          width,
          extension,
        },
        fileName,
      });
    }
  }

  handleOnDrop(acceptFile) {
    const { onModalOpen } = this.props;

    if (!acceptFile[0]) {
      onModalOpen('CONFIRM', {
        content: '파일이 선택되지 않았습니다.',
        closeText: '확인',
      });
      return;
    }
    const parsing = acceptFile[0].name.split('.');
    const extension = parsing.pop().toLowerCase();

    if (ACCEPT_FILETYPE.indexOf(extension) === -1) {
      onModalOpen('CONFIRM', {
        title: '지원하지 않는 파일',
        content: '로고 파일은 JPG 또는 PNG 파일만 업로드할 수 있습니다.',
        closeText: '확인',
      });
      return;
    }
    if (acceptFile[0].size > MAX_FILE_SIZE) {
      onModalOpen('CUSTOM_EMAIL_SETTING_LOGO_IMAGE_CONSTRAINTS_ALERT_MODAL', {
        alertType: 'fileSize',
      });
      return;
    }

    this.getBase64(acceptFile[0]);
  }

  getBase64(file) {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      this.handleConvertImageToBase64({
        base64: reader.result,
        fileName: file.name,
      });
    };
  }

  render() {
    return (
      <DropZone
        maxFiles={1}
        multiple={false}
        noClick
        ref={(ref) => {
          this.dropzoneRef = ref;
        }}
        useFsAccessApi={false}
        onDrop={this.handleOnDrop}
      >
        {({ getRootProps, getInputProps }) => (
          <div className="LogoImageDropZone box-8x align-center" {...getRootProps()}>
            <input {...getInputProps()} />
            <img alt="" className="LogoImageDropZone__size-img space-4x" src={logoSizeImage} />
            <div>
              <button
                className="LogoImageDropZone__button Btn Btn--primary Btn--light space-6x"
                type="button"
                onClick={this.handleClickFile}
              >
                로고 파일 찾기
                <ArrowIcon direction="right" ml="2px" />
              </button>
            </div>
            <div className="Card Card--primary Card--theme-flat">
              <ul className="CheckList align-left box-3x" style={{ padding: 30 }}>
                <li>이미지 형식은 JPG 또는 PNG 파일만 가능합니다.</li>
                <li>파일의 크기는 최대 300kb까지 지원합니다.</li>
              </ul>
            </div>
          </div>
        )}
      </DropZone>
    );
  }
}

LogoImageDropZone.propTypes = propTypes;
LogoImageDropZone.defaultProps = defaultProps;

export default LogoImageDropZone;
